import { Calculation } from 'final-form-calculate'
import { ProcedimentosAutomaticosAtendimentoIndividual } from 'types/enums'
import { emptyArray } from 'util/array'
import { MetaPath } from 'util/metaPath'
import { SoapState } from 'view/atendimentos/atendimento-individual/model'
import { SinaisVitaisAccordionModel } from 'view/atendimentos/components/MedicoesPanel/SinaisVitaisAccordion'
import { ProcedimentoAutomatico } from 'view/atendimentos/model-atendimento'
import {
  addOrRemoveAfericaoPressaoArterial,
  addOrRemoveAfericaoTemperatura,
  addOrRemoveGlicemiaCapilar,
} from 'view/atendimentos/utils/util-procedimentoAutomatico'

import { PlanoFormModel } from './PlanoForm'

export interface HasAccessProcedimentos {
  desenvolvimentoCrianca: boolean
  crescimentoCrianca: boolean
  glicemiaCapilar: boolean
}

export const createPlanoMedicoesCalculations = (
  plano: MetaPath<PlanoFormModel>,
  sinaisVitais: MetaPath<SinaisVitaisAccordionModel>,
  procedimentosAutomaticos: ProcedimentoAutomatico[],
  hasAccessProcedimentos: HasAccessProcedimentos
): Calculation[] => [
  {
    field: [
      sinaisVitais.pressaoArterialSistolica.absolutePath(),
      sinaisVitais.pressaoArterialDiastolica.absolutePath(),
    ],
    updates: {
      [plano.intervencoesProcedimentos.procedimentosPlano.procedimentos.absolutePath()]: (_, allValues: SoapState) => {
        const sinaisVitais = allValues?.objetivo?.sinaisVitais

        const listaProcedimentos =
          allValues.plano?.intervencoesProcedimentos?.procedimentosPlano?.procedimentos ?? emptyArray
        const codigosProcedimentosAutomaticosExcluidos =
          allValues.plano?.intervencoesProcedimentos?.procedimentosPlano?.codigosProcedimentosAutomaticosExcluidos ??
          emptyArray

        return addOrRemoveAfericaoPressaoArterial(
          sinaisVitais?.pressaoArterialSistolica,
          sinaisVitais?.pressaoArterialDiastolica,
          listaProcedimentos,
          procedimentosAutomaticos,
          codigosProcedimentosAutomaticosExcluidos,
          ProcedimentosAutomaticosAtendimentoIndividual.AFERICAO_PRESSAO_ARTERIAL
        )
      },
    },
  },
  {
    field: sinaisVitais.glicemia.absolutePath(),
    updates: {
      [plano.intervencoesProcedimentos.procedimentosPlano.procedimentos.absolutePath()]: (_, allValues: SoapState) => {
        const listaProcedimentos =
          allValues.plano?.intervencoesProcedimentos?.procedimentosPlano?.procedimentos ?? emptyArray
        const codigosProcedimentosAutomaticosExcluidos =
          allValues.plano?.intervencoesProcedimentos?.procedimentosPlano?.codigosProcedimentosAutomaticosExcluidos ??
          emptyArray

        return addOrRemoveGlicemiaCapilar(
          allValues?.objetivo?.sinaisVitais?.glicemia,
          hasAccessProcedimentos.glicemiaCapilar,
          listaProcedimentos,
          procedimentosAutomaticos,
          codigosProcedimentosAutomaticosExcluidos,
          ProcedimentosAutomaticosAtendimentoIndividual.GLICEMIA_CAPILAR
        )
      },
    },
  },
  {
    field: sinaisVitais.temperatura.absolutePath(),
    updates: {
      [plano.intervencoesProcedimentos.procedimentosPlano.procedimentos.absolutePath()]: (_, allValues: SoapState) => {
        const listaProcedimentos =
          allValues.plano?.intervencoesProcedimentos?.procedimentosPlano?.procedimentos ?? emptyArray
        const codigosProcedimentosAutomaticosExcluidos =
          allValues.plano?.intervencoesProcedimentos?.procedimentosPlano?.codigosProcedimentosAutomaticosExcluidos ??
          emptyArray

        return addOrRemoveAfericaoTemperatura(
          allValues.objetivo?.sinaisVitais?.temperatura,
          listaProcedimentos,
          procedimentosAutomaticos,
          codigosProcedimentosAutomaticosExcluidos,
          ProcedimentosAutomaticosAtendimentoIndividual.AFERICAO_DE_TEMPERATURA
        )
      },
    },
  },
]
